<template>
    <div>
        <VuePhoneNumberInput :counter="20"
                             prepend-icon="phone"
                             v-model="telephone"
                             :label="$storeCandidature.langueFormulaire == 'en' ? 'Phone' : 'Téléphone'"
                             required
                             clearable
                             :error="error"
                             :translations="translations"
                             @update="onUpdate"
                             @phone-number-blur="$storeCandidature.candidatureChanged = true"                             
                             error-color="red"
                             valid-color="green"
                             :preferred-countries="['FR']"
                             no-use-browser-locale>
        </VuePhoneNumberInput>
    </div>
</template>

<script>

    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';

    export default {
        components: {
            VuePhoneNumberInput
        },
        props: {
            telephone: null
        },

        data() {
            return {
                error: true,
                translations: {
                    countrySelectorLabel: this.$storeCandidature.langueFormulaire == 'en' ? 'Country code' : 'Code pays',
                    countrySelectorError: this.$storeCandidature.langueFormulaire == 'en' ? 'Select country' : 'Choisir un pays',
                    phoneNumberLabel: this.$storeCandidature.langueFormulaire == 'en' ? 'Phone number' : 'Numéro de téléphone',
                    example: this.$storeCandidature.langueFormulaire == 'en' ? 'Example :' : 'Exemple :'
                },
            }
        },
        methods: {

            onUpdate(phone) {
                this.$storeCandidature.sasCandidature.Identification.Telephone = phone.formatInternational;
                if (phone.isValid) {
                    this.error = false;
                }
                else {
                    this.error = true;
                }
            }
        }
    };
</script>

<style scoped>
</style>